// extracted by mini-css-extract-plugin
module.exports = {"banner":"CarBanner_banner___bdEo","bannerGift":"CarBanner_bannerGift__fm3zY"};